<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/herschel/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Recycled Novel Duffle",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel9recycled-novel-duffle.png" ].default
	},
	{
		title: "Outfitter 50L Wheeled Duffle",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel2outfitter-50l-wheeled-duffle.png" ].default
	},
	{
		title: "Recycled 15 inch Computer Backpack",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel7recycled-15-inch-computer-backpack.png" ].default
	},
	{
		title: "Retreat 15 inch Computer Backpack",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel8retreat-15-inch-computer-backpack.png" ].default
	},
	{
		title: "Recycled Classic Gym Bag",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel6recycled-classic-gym-bag.png" ].default
	},
	{
		title: "Recycled Classic Crossbody Tote",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel5recycled-classic-crossbody-tote.png" ].default
	},
	{
		title: "Recycled Chapter Travel Kit",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel4recycled-chapter-travel-kit.png" ].default
	},
	{
		title: "Recycled Classic Tote",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel3recycled-classic-tote.png" ].default
	},
	{
		title: "Classic Backpack",
		src: imagesGlob["../../images/brands/herschel/products/swaggerproductpagewebsiteproductsherschel1classic-backpack.png"].default
	}
];

</script>

<template lang="pug">
.page.page--brand.herschel
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/herschel/logo.webp')
				h1 Custom Herschel
			.image
				img(src='@static/images/brands/herschel/hero.jpg' alt='Woman along a waterfront with her back turned, wearing a Herschel backpack, blending timeless style with travel-ready design.')
	section.section.section--subhero
		.section__content
			.copy
				h3 Travel Everywhere, Travel Often
				p Custom Herschel by Swagger blends timeless design with practical functionality, crafting everyday essentials that are anything but ordinary. From backpacks built to move with you, to thoughtfully designed duffels and accessories, each piece is made to elevate the everyday. Inspired by travel, creativity, and culture, Herschel’s products are equally at home on city streets, global adventures, or your daily commute. Always with purpose, always with style.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="herschel")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/herschel/banner.jpg' alt='Herschel backpack displayed on top of a stack of recycled plastic bottles, highlighting sustainable design using EcoSystem™ fabrics.')
			.section__content
				.copy
					h2 STYLE MEETS SUSTAINABILITY
					p Herschel’s commitment to quality doesn’t stop at design, it extends to the planet. Many of their bestselling styles are now reimagined using EcoSystem™ recycled fabrics, helping reduce environmental impact without compromising performance or aesthetics. Featuring thoughtful details like recycled liners and trims, every eco-minded Herschel piece makes a statement: sustainability is always in style. It’s a smarter kind of everyday carry. Purposeful, planet-friendly, and built to last.

		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>